(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zenshade-header"]) return;
  try {
    
if(!customElements.get('zs-header'))customElements.define('zs-header',class extends HTMLElement{connectedCallback(){const menu=this.querySelector('details');if(!menu||this.dataset.ready)return;this.dataset.ready='true';const close=()=>{menu.open=false;menu.querySelector('summary').focus();};this.addEventListener('click',e=>{if(e.target.closest('[data-close-menu]'))close();else if(e.target.closest('.zs-menu-panel nav a,.zs-menu-cta'))menu.open=false;});this.addEventListener('keydown',e=>{if(e.key==='Escape'&&menu.open){e.preventDefault();close();}if(e.key==='Tab'&&menu.open){const focusable=[menu.querySelector('summary'),...menu.querySelectorAll('.zs-menu-panel a,.zs-menu-panel button')];const first=focusable[0],last=focusable[focusable.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}}});menu.addEventListener('toggle',()=>{menu.querySelector('summary').setAttribute('aria-label',menu.open?'Close menu':'Open menu');});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zenshade-product"]) return;
  try {
    
if(!customElements.get('zenshade-product')){customElements.define('zenshade-product',class extends HTMLElement{setMoney(element,formatted){
const money=document.createElement('span');
money.className='money';
money.textContent=formatted;
element.replaceChildren(money);
}
refreshCurrency(){
if(this.currencyFrame)cancelAnimationFrame(this.currencyFrame);
this.currencyFrame=requestAnimationFrame(()=>{this.currencyFrame=0;window.bucksCC?.reConvert?.();});
}
initAddons(){
const form=this.querySelector('.buy-form');
const update=()=>{
const selected=this.querySelector('[data-offer]:checked');
const base=Number(selected.dataset.basePrice);
const extra=Array.from(this.querySelectorAll('[data-addon]:checked')).reduce((sum,input)=>sum+Number(input.dataset.price),0);
const total=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.dataset.currency||'USD'}).format((base+extra)/100);
this.querySelectorAll('[data-offer-total],.sticky-buy [data-price],[data-dock-total]').forEach(el=>this.setMoney(el,total));
this.refreshCurrency();
const error=this.querySelector('[data-addon-error]');if(error)error.hidden=true;
};
this.addEventListener('change',event=>{if(event.target.matches('[data-addon],[data-offer]'))queueMicrotask(update);},{signal:this.dockAbort.signal});
form.addEventListener('submit',async event=>{
const addons=Array.from(this.querySelectorAll('[data-addon]:checked'));
if(!addons.length)return;
event.preventDefault();
if(this.adding)return;
const error=this.querySelector('[data-addon-error]');
if(addons.some(input=>!input.dataset.variant)){error.hidden=false;error.scrollIntoView({block:'center',behavior:'smooth'});return;}
const data=new FormData(form);
const items=[{id:data.get('id'),quantity:Number(data.get('quantity'))},...addons.map(input=>({id:input.dataset.variant,quantity:1}))];
this.adding=true;
const buttons=Array.from(this.querySelectorAll('button[type="submit"]'));
buttons.forEach(button=>{button.disabled=true;button.setAttribute('aria-busy','true');});
try{
const response=await fetch(this.dataset.cartUrl+'/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
const result=await response.json();
if(!response.ok)throw new Error(result.description||result.message);
window.location.assign(this.dataset.cartUrl);
}catch(exception){error.textContent=exception.message;error.hidden=false;buttons.forEach(button=>{button.disabled=false;button.removeAttribute('aria-busy');});this.adding=false;}
},{signal:this.dockAbort.signal});
update();
}
initDock(){
this.dockAbort?.abort();
this.dockAbort=new AbortController();
const slot=this.querySelector('.zs-atc-slot');
const dock=this.querySelector('.zs-atc-dock');
const sticky=this.querySelector('.sticky-buy');
const button=dock.querySelector('button');
const update=()=>{
this.dockFrame=0;
const height=button.offsetHeight;
slot.style.minHeight=height+'px';
const rect=slot.getBoundingClientRect();
const viewport=window.visualViewport;
const bottom=viewport?viewport.offsetTop+viewport.height:window.innerHeight;
const above=rect.bottom>bottom;
const below=rect.bottom<=0;
const editing=/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName)&&document.activeElement?.type!=='radio';
dock.classList.toggle('is-docked',above&&!editing);
sticky.hidden=!below||editing;
sticky.querySelector('button').disabled=button.disabled;
};
this.queueDock=()=>{if(!this.dockFrame)this.dockFrame=requestAnimationFrame(update);};
const options={passive:true,signal:this.dockAbort.signal};
window.addEventListener('scroll',this.queueDock,options);
window.addEventListener('resize',this.queueDock,options);
window.visualViewport?.addEventListener('resize',this.queueDock,options);
this.addEventListener('focusin',this.queueDock,{signal:this.dockAbort.signal});
this.addEventListener('focusout',this.queueDock,{signal:this.dockAbort.signal});
this.dockObserver=new ResizeObserver(this.queueDock);
this.dockObserver.observe(this.querySelector('.product-grid'));
this.dockObserver.observe(dock);
this.stateObserver=new MutationObserver(this.queueDock);
this.stateObserver.observe(button,{attributes:true,attributeFilter:['disabled']});
update();
}
disconnectedCallback(){this.dockAbort?.abort();this.dockObserver?.disconnect();this.stateObserver?.disconnect();cancelAnimationFrame(this.dockFrame);cancelAnimationFrame(this.currencyFrame);delete this.dataset.ready;}
connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';this.initDock();this.initAddons();this.addEventListener('change',event=>{const option=event.target;if(!option.matches('[data-offer]'))return;const offerLabel=this.querySelector('[data-offer-label]');if(offerLabel)offerLabel.textContent=option.value==='2'?'TWO SETS · SAVE 15%':'THE COMPLETE SET';this.querySelectorAll('.price-row [data-price]').forEach(el=>this.setMoney(el,option.dataset.total));this.refreshCurrency();const compare=this.querySelector('s[data-compare]');if(compare){this.setMoney(compare,option.dataset.compare||'');compare.hidden=!option.dataset.compare;}});this.addEventListener('click',event=>{const button=event.target.closest('[data-gallery-target]');if(!button)return;this.querySelectorAll('[data-gallery-panel]').forEach(panel=>panel.hidden=panel.id!==button.dataset.galleryTarget);this.querySelectorAll('[data-gallery-target]').forEach(thumb=>thumb.setAttribute('aria-pressed',String(thumb===button)));});const select=this.querySelector('[data-variant-select]');if(select){select.addEventListener('change',()=>{const option=select.selectedOptions[0];this.querySelectorAll('[data-price]').forEach(el=>this.setMoney(el,option.dataset.price));this.refreshCurrency();const compare=this.querySelector('s[data-compare]');if(compare){this.setMoney(compare,option.dataset.compare||'');compare.hidden=!option.dataset.compare;}const submit=this.querySelector('[data-submit]');submit.disabled=option.dataset.available!=='true';submit.textContent=submit.disabled?submit.dataset.soldOut:submit.dataset.add;const url=new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState({},'',url);if(option.dataset.media){this.querySelector('[data-media-id="'+option.dataset.media+'"]')?.click();}});}}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zenshade-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('zs-reviews'))customElements.define('zs-reviews',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';const form=this.querySelector('.zsr-form');this.querySelector('[data-open-review]')?.addEventListener('click',()=>{form.open=true;});if(form?.querySelector('.zsr-success,.errors'))form.open=true;const list=this.querySelector('.zsr-list');if(!list)return;let limit=4;const cards=Array.from(list.children);const more=this.querySelector('[data-review-more]');const render=()=>{Array.from(list.children).forEach((el,i)=>el.hidden=i>=limit);more.hidden=limit>=cards.length;};this.querySelector('[data-review-sort]')?.addEventListener('change',e=>{const order=e.target.value;cards.sort((a,b)=>order==='highest'?Number(b.dataset.rating)-Number(a.dataset.rating):order==='lowest'?Number(a.dataset.rating)-Number(b.dataset.rating):b.dataset.date.localeCompare(a.dataset.date));cards.forEach(c=>list.append(c));limit=4;render();});more?.addEventListener('click',()=>{limit+=4;render();});render();}});

  } catch(e) { console.error(e); }
})();
})();
